import {axios as http} from "@/plugins/http"

export default class ApiBase {
    static getPhantomsToUser(id) {
        return http.post("/api/v1/user/user/phantoms-to-user", {
            "user_id": id,
        });
    }

    static selectPhantomToUser(phantomId, userId) {
        return http.post("/api/v1/user/user/select-phantom-to-user", {
            "phantom_id": phantomId,
            "user_id": userId,
        });
    }
}
